import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import SEOHead from "../components/shared/SEOHead";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Privacy Policy | Hitech Transit"
        description="Hitech Transit privacy policy. How we collect, use, and protect your personal data. GDPR compliant."
        canonical="/privacy"
      />
      <Header />
      
      <main className="pt-20">
        <section className="bg-[#0F172A] py-16">
          <div className="container-max px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-['Outfit'] font-bold text-white">Privacy Policy</h1>
          </div>
        </section>

        <section className="section-padding">
          <div className="container-max">
            <div className="max-w-3xl mx-auto">
              <p className="text-sm text-slate-500 mb-8">Last updated: January 2026</p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">1. Information We Collect</h2>
              <p className="text-slate-600 mb-4">
                We collect personal information you provide when requesting quotes, booking services, or contacting us. 
                This includes your name, email address, phone number, and addresses involved in your move.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">2. How We Use Your Information</h2>
              <p className="text-slate-600 mb-4">
                We use your information to:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
                <li>Process your quotes and bookings</li>
                <li>Communicate about your move</li>
                <li>Send confirmation and reminder emails</li>
                <li>Process payments</li>
                <li>Improve our services</li>
              </ul>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">3. Information Sharing</h2>
              <p className="text-slate-600 mb-4">
                We do not sell your personal information. We may share information with payment processors and 
                third-party service providers necessary to deliver our services.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">4. Data Security</h2>
              <p className="text-slate-600 mb-4">
                We implement appropriate security measures to protect your personal information. Payment data is 
                processed securely through Stripe and PayPal.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">5. Your Rights</h2>
              <p className="text-slate-600 mb-4">
                Under GDPR, you have the right to:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Data portability</li>
              </ul>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">6. Data Retention</h2>
              <p className="text-slate-600 mb-4">
                We retain your personal information for as long as necessary to provide our services and comply 
                with legal obligations, typically for 6 years after your last interaction with us.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">7. Contact Us</h2>
              <p className="text-slate-600 mb-4">
                For privacy-related enquiries, please contact us at hello@hitechtransit.com or call 07346 209593.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
